(function () {
  const story = document.querySelector('.story');
  if (!story) return;

  // Ensure prelude visible on load
  story.removeAttribute('data-prelude');

  const contents = story.querySelectorAll('.chapter-content');
  const img = document.getElementById('storyImage');

  function closeAll(exceptId) {
    contents.forEach((c) => {
      const id = c.getAttribute('data-content');
      if (exceptId && id === exceptId) return;
      c.classList.remove('is-open');
      c.setAttribute('aria-hidden', 'true');
      c.style.height = '0px';
    });
  }

  function openContent(id) {
    const c = story.querySelector('.chapter-content[data-content="' + id + '"]');
    if (!c) return;

    c.classList.add('is-open');
    c.setAttribute('aria-hidden', 'false');

    c.style.height = '0px';
    void c.offsetHeight;
    c.style.height = c.scrollHeight + 'px';

    c.addEventListener('transitionend', function handler(e) {
      if (e.propertyName === 'height' && c.classList.contains('is-open')) {
        c.style.height = 'auto';
      }
      c.removeEventListener('transitionend', handler);
    });
  }

  function swapImage(url) {
    if (!img || !url) return;
    img.style.opacity = '0';
    setTimeout(() => {
      img.src = url;
      img.onload = () => {
        img.style.opacity = '1';
      };
      setTimeout(() => {
        img.style.opacity = '1';
      }, 220);
    }, 150);
  }

  function setPreludeState(chapterIsOpen) {
    if (chapterIsOpen) story.setAttribute('data-prelude', 'hidden');
    else story.removeAttribute('data-prelude');
  }

  function openChapter(id, url) {
    closeAll(id);
    openContent(id);
    swapImage(url);
    setPreludeState(true);
    history.pushState({ chapter: id }, '', '#' + id);
  }

  function closeChapters() {
    closeAll();
    setPreludeState(false);
    history.pushState({}, '', '#');
  }

  document.addEventListener('click', (e) => {
    const back = e.target.closest('[data-back-to-top]');
    if (back && story.contains(back)) {
      // reset state + show prelude
      e.preventDefault();

      closeAll();
      setPreludeState(false);

      // remove hash without reloading
      history.pushState({}, '', window.location.pathname + window.location.search);

      // optional: scroll to top/hero smoothly
      const targetSel = back.getAttribute('href');
      const target = targetSel ? document.querySelector(targetSel) : null;
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });

      return;
    }

    const a = e.target.closest('.chapter-trigger');
    if (!a) return;
    if (!story.contains(a)) return;

    e.preventDefault();

    const id = a.getAttribute('data-chapter');
    const url = a.getAttribute('data-image');

    const current = story.querySelector('.chapter-content[data-content="' + id + '"]');
    const isAlreadyOpen = current && current.classList.contains('is-open');

    if (isAlreadyOpen) {
      // close chapter AND restore prelude
      closeAll();
      setPreludeState(false);
      history.pushState({}, '', window.location.pathname + window.location.search);
      return;
    }

    openChapter(id, url);
  });

  window.addEventListener('popstate', () => {
    const hash = (location.hash || '').replace('#', '');
    if (!hash) {
      closeAll();
      setPreludeState(false);
      return;
    }

    const trigger = story.querySelector('.chapter-trigger[data-chapter="' + hash + '"]');
    if (!trigger) {
      closeAll();
      setPreludeState(false);
      return;
    }

    closeAll(hash);
    openContent(hash);
    swapImage(trigger.getAttribute('data-image'));
    setPreludeState(true);
  });
})();
